import { css } from '@emotion/core'
import { Select, TextArea } from '@fs/zion-ui'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { getLastPathElement } from '../../../util/StringUtil'
import { DmcDatePicker } from '../DmcDatePicker/DmcDatePicker'
import DmcPlaceStandards from '../DmcPlaceStandards'
import { DmcRow } from '../DmcRow'
import { ORIGINAL_DATE_FORMAT, FORMAL_DATE_FORMAT, convertDateString } from '../../../util/DateUtil'

export default () => {}

/* eslint-disable react-hooks/exhaustive-deps */

const selectCss = css`
  min-width: 150px;
  max-width: 200px;
`

const dateCss = css`
  min-width: 150px;
  max-width: 300px;
`

const placeCss = css`
  min-width: 150px;
  max-width: 300px;
`

export function DmcConclusionFactUIOnly({
  type,
  setType,
  typeOptions,
  associationType,
  setAssociation,
  associationOptions,
  date,
  setDate,
  place,
  setPlace,
  value,
  setValue,
  editable,
}) {
  const { t } = useTranslation()
  const disableTypeSelect = !editable || typeOptions.length === 1
  const disableAssociationSelect = !editable
  const testType = type.split('/').pop().toLowerCase()
  return (
    <DmcRow>
      <div css={selectCss}>
        <Select
          data-testid="FactType"
          id={`${testType}FactType`}
          disabled={disableTypeSelect}
          label={t('type', 'Type')}
          options={typeOptions}
          value={type}
          onChange={(event) => {
            setType(event.target.value)
          }}
        />
      </div>
      {associationOptions && (
        <div css={selectCss}>
          <Select
            data-testid="Association"
            id={`${testType}Association`}
            disabled={disableAssociationSelect}
            label={t('association', 'Association')}
            options={associationOptions}
            value={associationType}
            onChange={(event) => {
              setAssociation(event.target.value)
            }}
          />
        </div>
      )}
      {getLastPathElement(type) === 'LifeSketch' ? (
        <TextArea label={t('value', 'Value')} value={value} onChange={(e) => setValue(e.target.value)} />
      ) : (
        <>
          <div css={dateCss}>
            <DmcDatePicker
              idType={testType}
              disabled={!editable}
              selectedItem={date}
              setSelectedItem={(e) => {
                if (e) {
                  const newDate = {
                    original: e ? e?.original : '',
                    formal: convertDateString(e ? e?.original : '', ORIGINAL_DATE_FORMAT, FORMAL_DATE_FORMAT),
                    primaryText: e ? e?.primaryText : '',
                  }
                  setDate(newDate)
                }
              }}
            />
          </div>
          <div css={placeCss}>
            <DmcPlaceStandards
              idType={testType}
              editable={editable}
              selectedItem={place}
              setSelectedItem={(newSelectedItem) => {
                setPlace(newSelectedItem)
              }}
            />
          </div>
        </>
      )}
    </DmcRow>
  )
}

DmcConclusionFactUIOnly.prototype = {
  type: PropTypes.string,
  setType: PropTypes.func,
  typeOptions: PropTypes.arrayOf({
    label: PropTypes.string,
    value: PropTypes.string,
  }),
  associatedType: PropTypes.string,
  setAssociation: PropTypes.func,
  associationOptions: PropTypes.arrayOf({
    label: PropTypes.string,
    value: PropTypes.string,
  }),
  date: PropTypes.shape({
    originalText: PropTypes.string,
    standard: PropTypes.shape({
      primaryText: PropTypes.string,
      original: PropTypes.string,
      earliestAstro: PropTypes.number,
      yearRange: PropTypes.string,
      formal: PropTypes.string,
    }),
  }),
  setDate: PropTypes.func,
  place: PropTypes.shape({
    originalText: PropTypes.string,
    standard: PropTypes.shape({
      id: PropTypes.number,
      standardizedText: PropTypes.string,
      placeType: PropTypes.string,
      yearRange: PropTypes.string,
      location: PropTypes.shape({
        latitude: PropTypes.number,
        longitude: PropTypes.number,
      }),
    }),
  }),
  setPlace: PropTypes.func,
  value: PropTypes.string,
  setValue: PropTypes.func,
  editable: PropTypes.bool,
}

/* eslint-enable react-hooks/exhaustive-deps */
